export const TOGGLE_SIDEBAR = 'TOGGLE_SIDEBAR';

export const OPEN_MOBILE_SIDEBAR = 'OPEN_MOBILE_SIDEBAR';
export const CLOSE_MOBILE_SIDEBAR = 'CLOSE_MOBILE_SIDEBAR';
